import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {selectSteps, setActiveStep} from '../redux/slices/lesson';
import {faKeyboard, faCheck, faFont, faLineColumns, faBook, faScalpelLineDashed} from '@fortawesome/pro-light-svg-icons';

import {
  APP_READING,
  APP_WRITING,
  APP_WORD_WORK,
  APP_WORD_SORT,
  APP_WORD_DIVISION,
  APP_ASSESSMENT,
  APP_TITLES,
} from '../constants';
import styles from '../css/MenuDrawer.module.css';
import baseStyles from '../css/Base.module.css';

export default function PrimaryAppBar({isMenuOpen, toggleMenu}) {
  const steps = useSelector(selectSteps);
  const dispatch = useDispatch();

  function handleClickStep(index) {
    dispatch(setActiveStep(index));
    toggleMenu(false);
  }

  function handleClickExercise(index, stepIndex, exercise) {
    const {_id: exerciseID} = exercise;
    window.open(`/exercise/${exerciseID}`);
    toggleMenu(false);
  }

  function renderStep(step, index) {
    return (
      <React.Fragment key={step.name}>
        <ListItem button onClick={() => handleClickStep(index)}>
          <ListItemText primary={step.name} classes={{primary: baseStyles.bold}} />
        </ListItem>

        {step.exercises.map((exercise, exerciseIndex) => renderExercise(exercise, exerciseIndex, index))}
      </React.Fragment>
    );
  }

  function renderExerciseIcon(type) {
    if (type === APP_READING) return <FontAwesomeIcon icon={faBook} />;
    else if (type === APP_WORD_WORK) return <FontAwesomeIcon icon={faFont} />;
    else if (type === APP_WORD_SORT) return <FontAwesomeIcon icon={faLineColumns} />;
    else if (type === APP_WORD_DIVISION) return <FontAwesomeIcon icon={faScalpelLineDashed} />;
    else if (type === APP_WRITING) return <FontAwesomeIcon icon={faKeyboard} />;
    else if (type === APP_ASSESSMENT) return <FontAwesomeIcon icon={faCheck} />;
  }

  function renderExercise(exercise, index, stepIndex) {
    return (
      <ListItem
        button
        key={exercise._id}
        className={styles.nested}
        onClick={() => handleClickExercise(index, stepIndex, exercise)}
      >
        <ListItemIcon>{renderExerciseIcon(exercise.type)}</ListItemIcon>
        <ListItemText primary={exercise?.name ?? APP_TITLES[exercise.type]} />
      </ListItem>
    );
  }

  return (
    <Drawer open={isMenuOpen} onClose={() => toggleMenu(false)}>
      <List className={styles['menu-list']}>{steps.map(renderStep)}</List>
    </Drawer>
  );
}
